/* FOODHUB — jauges « livraisons offertes » du panier (tiroir + page panier).
   Francos indépendants, chacun avec sa propre jauge :
     - épicerie sèche (produits marqués sec/alcool)  : dès SEC_TH, colis sec offert (72h, ≤ 28 €)
     - envoi direct producteur (marqué fournisseur)  : dès FOURN_TH par producteur (ex. Kasnodar)
   30/09/2026 — FRANCO VIANDE SUPPRIMÉ (règle Salim : jamais de franco sur le frais). La jauge « Viande »
   et le rappel « À débloquer aussi : viande » ne s'affichent plus ; la viande est comptée avec les
   autres produits frais/surgelés (« ont leurs propres frais de livraison »). Côté checkout, le franco
   viande est coupé dans la remise d'app « Avantages FOODHUB » (Seuil viande = 0).
   La famille de chaque ligne vient du métachamp produit foodhub.livraison, exposé par la
   section fh-familles-panier (Section Rendering API), donc toujours à jour du panier réel.
   Remplace l'ancienne barre .fh-ship (masquée ici par CSS).
   FH 20/09/2026 (perf) : une seule passe réseau à la fois (+ une de rattrapage si le panier a
   bougé pendant la passe) ; l'observateur DOM ne relance plus une passe à chaque mutation,
   seulement quand un tiroir re-rendu n'a pas encore sa jauge. */
(function () {
  "use strict";
  var SEC_TH = 25000, FOURN_TH = 12000; // centimes
  /* Où envoyer le client pour compléter chaque palier. */
  var URLS = { sec: "/collections/epicerie-fine", fourn: { "Kasnodar Caviar": "/collections/caviar" } };
  var cache = {}, sig = "", busy = false, pending = false, timer;

  function css() {
    if (document.getElementById("fh-fr-css")) return;
    var s = document.createElement("style");
    s.id = "fh-fr-css";
    s.textContent =
      ".fh-ship{display:none!important}" +
      ".fh-fr{border:1px solid #E7DFC9;background:#FBF7EE;border-radius:12px;padding:12px 13px;margin:0 0 12px;font-family:Archivo,sans-serif;box-sizing:border-box}" +
      ".fh-fr__head{display:flex;align-items:center;justify-content:space-between;gap:8px;font-size:11px;letter-spacing:.12em;text-transform:uppercase;font-weight:800;color:#8a6d1a;margin-bottom:10px}" +
      ".fh-fr__count{font-size:10px;letter-spacing:.06em;background:#fff;border:1px solid #E7DFC9;border-radius:999px;padding:3px 8px;color:#5f5030;font-weight:700}" +
      ".fh-fr__g{display:flex;gap:10px;align-items:flex-start;padding:9px 0;border-top:1px solid #EFE8D6}" +
      ".fh-fr__g:first-of-type{border-top:0;padding-top:0}" +
      ".fh-fr__ico{flex:0 0 auto;width:28px;height:28px;border-radius:50%;background:#fff;border:1.5px solid #C9A84C;display:flex;align-items:center;justify-content:center;font-size:14px;line-height:1;transition:all .3s}" +
      ".fh-fr__body{flex:1;min-width:0}" +
      ".fh-fr__txt{font-size:13px;color:#3a3228;line-height:1.3;display:flex;justify-content:space-between;gap:8px;align-items:baseline}" +
      ".fh-fr__txt b{font-weight:700;color:#1A1208}" +
      ".fh-fr__pct{font-size:11px;font-weight:700;color:#8a7a52;white-space:nowrap;font-variant-numeric:tabular-nums}" +
      ".fh-fr__bar{position:relative;height:7px;background:#EBE3CF;border-radius:99px;overflow:hidden;margin:6px 0 5px}" +
      ".fh-fr__bar i{display:block;height:100%;width:0;background:linear-gradient(90deg,#C9A84C,#E2C56E);border-radius:99px;transition:width .45s cubic-bezier(.2,.8,.2,1),background .35s}" +
      ".fh-fr__hint{font-size:11.5px;color:#8a7a52;line-height:1.35}" +
      ".fh-fr__hint strong{color:#1A1208;font-weight:700}" +
      ".fh-fr__g.is-on .fh-fr__ico{background:#2e7d32;border-color:#2e7d32;color:#fff;transform:scale(1.06)}" +
      ".fh-fr__g.is-on .fh-fr__bar i{background:#2e7d32}" +
      ".fh-fr__g.is-on .fh-fr__hint{color:#2e7d32}" +
      ".fh-fr__g.is-on .fh-fr__pct{color:#2e7d32}" +
      ".fh-fr__more{font-size:11px;color:#8a7a52;line-height:1.4;margin-top:9px;padding-top:8px;border-top:1px dashed #E7DFC9}" +
      ".fh-fr__more b{color:#5f5030;font-weight:700}" +
      ".fh-fr__more a{color:#8a6d1a;text-decoration:underline}" +
      ".fh-fr__go{display:inline-block;margin-left:6px;color:#8a6d1a;font-weight:700;text-decoration:none;border-bottom:1px solid rgba(138,109,26,.5);white-space:nowrap}" +
      ".fh-fr__go:hover{color:#1A1208;border-bottom-color:#1A1208}" +
      ".fh-fr.is-all{border-color:#bfe0bf;background:#F1F8EE}" +
      "@keyframes fhFrPop{0%{transform:scale(.6);opacity:0}70%{transform:scale(1.15)}100%{transform:scale(1);opacity:1}}" +
      ".fh-fr__g.is-new .fh-fr__ico{animation:fhFrPop .5s ease-out}";
    (document.head || document.documentElement).appendChild(s);
  }

  function fmt(c) { return (c / 100).toFixed(2).replace(/\.00$/, "").replace(".", ",") + " €"; }
  function norm(s) { return String(s || "").trim().toLowerCase(); }

  /* Repli si la section n'a pas répondu : tags produit (ambient/ambiante = sec). */
  function tagsFor(h) {
    if (cache[h]) return Promise.resolve(cache[h]);
    return fetch("/products/" + h + ".js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { var t = (p && p.tags) || []; cache[h] = t; return t; })
      .catch(function () { cache[h] = []; return []; });
  }
  function familleFromTags(tags) {
    var amb = false;
    for (var i = 0; i < tags.length; i++) {
      var t = norm(tags[i]);
      if (t.indexOf("expedition:") === 0) return "fournisseur";
      if (t === "surgelé" || t === "surgele") return "surgele";
      if (t === "frais") return "frais";
      if (t === "ambient" || t === "ambiante") amb = true;
    }
    return amb ? "sec" : "";
  }

  function familles() {
    return fetch("/?sections=fh-familles-panier", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.ok ? r.json() : {}; })
      .then(function (j) {
        var html = j && j["fh-familles-panier"];
        if (!html) return null;
        var m = html.match(/<script[^>]*data-fh-familles[^>]*>([\s\S]*?)<\/script>/);
        if (!m) return null;
        try { return JSON.parse(m[1]); } catch (e) { return null; }
      })
      .catch(function () { return null; });
  }

  function clear() {
    var n = document.querySelectorAll(".fh-fr");
    for (var i = 0; i < n.length; i++) n[i].parentNode && n[i].parentNode.removeChild(n[i]);
  }

  function gauge(id, ico, label, sub, total, th, onTxt, url) {
    var on = total >= th, rem = Math.max(0, th - total);
    var pct = Math.max(4, Math.min(100, total / th * 100));
    return {
      id: id, on: on,
      html:
        '<div class="fh-fr__g' + (on ? " is-on" : "") + '" data-fh-g="' + id + '">' +
          '<span class="fh-fr__ico">' + (on ? "✓" : ico) + "</span>" +
          '<div class="fh-fr__body">' +
            '<div class="fh-fr__txt"><span><b>' + label + "</b> " + sub + "</span>" +
              '<span class="fh-fr__pct">' + (on ? "débloqué" : Math.round(pct) + " %") + "</span></div>" +
            '<div class="fh-fr__bar"><i style="width:' + pct + '%"></i></div>' +
            '<div class="fh-fr__hint">' + (on ? "🎉 " + onTxt : "Plus que <strong>" + fmt(rem) + "</strong> pour débloquer la <strong>livraison offerte</strong>" + (url ? ' <a class="fh-fr__go" href="' + url + '">Compléter →</a>' : "")) + "</div>" +
          "</div>" +
        "</div>"
    };
  }

  function render(tot) {
    var gs = [], more = [];
    if (tot.sec > 0) gs.push(gauge("sec", "🥫", "Épicerie sèche", "· livraison offerte dès " + fmt(SEC_TH), tot.sec, SEC_TH, "Livraison offerte sur votre épicerie sèche (colis 72h, France)", URLS.sec));
    else more.push('<a href="' + URLS.sec + '"><b>épicerie sèche</b></a> dès ' + fmt(SEC_TH));
    var vendors = Object.keys(tot.fourn);
    if (vendors.length) {
      vendors.forEach(function (v) {
        gs.push(gauge("fourn-" + v, "📦", v, "· envoi direct offert dès " + fmt(FOURN_TH), tot.fourn[v], FOURN_TH, "Envoi direct " + v + " offert (France)", URLS.fourn[v] || null));
      });
    } else more.push('<a href="' + URLS.fourn["Kasnodar Caviar"] + '"><b>caviar Kasnodar</b></a> dès ' + fmt(FOURN_TH) + " (envoi direct)");

    if (!gs.length) return clear();
    var nOn = gs.filter(function (g) { return g.on; }).length;
    var html =
      '<div class="fh-fr__head"><span>🎁 Livraisons offertes</span><span class="fh-fr__count">' + nOn + "/" + gs.length + " débloqué" + (nOn > 1 ? "s" : "") + "</span></div>" +
      gs.map(function (g) { return g.html; }).join("") +
      (more.length ? '<div class="fh-fr__more">À débloquer aussi : ' + more.join(" · ") + ".</div>" : "") +
      (tot.autres > 0 ? '<div class="fh-fr__more">Les produits frais et surgelés (viandes comprises) ont leurs propres frais de livraison.</div>' : "");

    document.querySelectorAll(".checkout-button").forEach(function (btn) {
      var cont = btn.parentElement;
      if (!cont) return;
      var blk = cont.querySelector(":scope > .fh-fr");
      var prev = {};
      if (blk) blk.querySelectorAll(".fh-fr__g").forEach(function (g) { prev[g.getAttribute("data-fh-g")] = g.classList.contains("is-on"); });
      if (!blk) { blk = document.createElement("div"); blk.className = "fh-fr"; cont.insertBefore(blk, btn); }
      blk.classList.toggle("is-all", nOn === gs.length);
      blk.innerHTML = html;
      /* petite animation quand un palier vient d'être franchi */
      blk.querySelectorAll(".fh-fr__g.is-on").forEach(function (g) {
        if (prev[g.getAttribute("data-fh-g")] === false) g.classList.add("is-new");
      });
    });
  }

  /* Fin de passe : si le panier a bougé pendant la passe, on en refait UNE seule. */
  function done() { busy = false; if (pending) { pending = false; upd(); } }

  function upd() {
    if (!document.querySelector(".checkout-button")) return;
    if (busy) { pending = true; return; }
    busy = true;
    Promise.all([
      fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }),
      familles()
    ]).then(function (res) {
      var items = (res[0] && res[0].items) || [], map = res[1] || {};
      if (!items.length) { sig = "0"; clear(); return done(); }
      return Promise.all(items.map(function (l) {
        var f = map[l.key] && map[l.key].f;
        if (f !== undefined && f !== null && f !== "") return Promise.resolve(f);
        if (map[l.key]) return Promise.resolve("");           // marqueur absent : non éligible
        return tagsFor(l.handle).then(familleFromTags);         // section indisponible : repli tags
      })).then(function (fams) {
        var tot = { sec: 0, fourn: {}, autres: 0 };
        for (var i = 0; i < items.length; i++) {
          var it = items[i], lp = it.final_line_price != null ? it.final_line_price : it.line_price, f = norm(fams[i]);
          if (f === "sec" || f === "alcool") tot.sec += lp;
          else if (f === "fournisseur") { var v = it.vendor || "producteur"; tot.fourn[v] = (tot.fourn[v] || 0) + lp; }
          else tot.autres += lp;
        }
        var s = JSON.stringify(tot) + "|" + document.querySelectorAll(".fh-fr").length;
        if (s !== sig) { sig = s; css(); render(tot); }
        done();
      });
    }).catch(function () { done(); });
  }

  /* Un tiroir/panier avec bouton de paiement mais sans jauge ? (tiroir re-rendu par le thème) */
  function manque() {
    var btns = document.querySelectorAll(".checkout-button");
    for (var i = 0; i < btns.length; i++) {
      var c = btns[i].parentElement;
      if (c && !c.querySelector(":scope > .fh-fr")) return true;
    }
    return false;
  }

  function boot() { css(); upd(); }
  if (document.readyState !== "loading") boot();
  document.addEventListener("DOMContentLoaded", boot);
  window.addEventListener("load", boot);
  document.addEventListener("shopify:section:load", boot);
  /* Changements de panier : événements (fh-cart-refresh.js les émet après /cart/add|change|update|clear).
     450 ms laisse au thème le temps de re-rendre le tiroir avant qu'on y écrive. */
  ["cart:refresh", "cart:updated"].forEach(function (ev) {
    document.addEventListener(ev, function () { clearTimeout(timer); timer = setTimeout(upd, 450); });
  });
  new MutationObserver(function (muts) {
    if (sig === "0") return;                      // panier vide : rien à dessiner, les événements suffisent
    for (var i = 0; i < muts.length; i++) {
      var t = muts[i].target;
      if (t && t.closest && t.closest(".fh-fr")) continue;   // nos propres rendus
      if (manque()) { clearTimeout(timer); timer = setTimeout(upd, 300); }
      return;
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
